import { TeamListDTO } from './team-list.dto';
import { BaseDTO } from '../global/base.dto';

export class TeamAccessDTO extends BaseDTO {

    access: Array<TeamListDTO>;

}
